import { addToGlobalThisRet } from "@plugins";

function setBgFromDataSrc() {
    const itemNeedBg = document.querySelectorAll(".js-set-bg-from-data");

    if (itemNeedBg) {
        itemNeedBg.forEach((item) => {
            if (item.dataset.bgSrc) {
                item.style.background = `url(${item.dataset.bgSrc}) center center/cover no-repeat`;
            } else if (item.dataset.bgWebp) {
                item.style.background = `url(${item.dataset.bgWebp}) center center/cover no-repeat`;
            } else if (item.dataset.bgSrc && item.dataset.bgWebp) {
                item.style.background = `
                    url(${
                        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
                            ? item.dataset.bgSrc
                            : item.dataset.bgWebp
                    }) center center/cover no-repeat`;
            }
        });
    }
}

window.addEventListener("load", setBgFromDataSrc());

addToGlobalThisRet(setBgFromDataSrc, "setBgFromDataSrc");
